/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPullRequest = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 5v9.127c1.724.445 3 2.012 3 3.873 0 2.206-1.794 4-4 4s-4-1.794-4-4a4.007 4.007 0 0 1 3-3.874V7h-5V5zM6 2c2.206 0 4 1.794 4 4a4.007 4.007 0 0 1-3 3.873V22H5V9.874A4.007 4.007 0 0 1 2 6c0-2.206 1.794-4 4-4zm12 14c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zM6 4c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPullRequest as PullRequest };
